import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-notice-layout',
  templateUrl: './notice-layout.component.html',
  styleUrls: ['./notice-layout.component.css']
})
export class NoticeLayoutComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
